import { Button, Icon } from "react-bulma-components";
import { useTranslation } from "react-i18next";
import { fbAuth } from "../../firebase";

export const SignOutButton = () => {
  const { t, i18n } = useTranslation();

  return (
    <Button
      color="info"
      onClick={async () => await fbAuth.signOut()}>
      <Icon>
        <i className="icon-logout" aria-hidden="true"></i>
      </Icon>
      <span>{t("sign-out")}</span>
    </Button>
  )
}